import React, { Component, Fragment } from "react";
import { CostEstimateRowsCalculator } from "../services/costEstimateRowsService";

function Interval(props) {
    if (props.columnIndex === 0) {
        if (props.isEditable) {
            return (
                <input
                    className="form-control"
                    min="0"
                    onChange={event =>
                        props.onQuantityChange(props.rowIndex, event)
                    }
                    type="number"
                    value={props.multiplier}
                />
            );
        } else {
            return (
                <input
                    className="form-control"
                    type="number"
                    value={props.multiplier}
                    readOnly
                />
            );
        }
    }

    return props.column.get(props);
}

class CostEstimateSpread extends Component {
    getSpreadSelectboxLabels = () => {
        const { intervals } = this.props.globalSettings;

        let spread = [];
        for (let i = 0; i < intervals.length; i++) {
            spread.push(intervals[i][0] + "-" + intervals[i][4] + " st");
        }
        return spread;
    };

    headings = [
        {
            get: multiplier => multiplier,
            heading: "Antal",
            name: "quantity"
        },
        {
            get: props => {
                return CostEstimateRowsCalculator.getTotalWeight(props);
            },
            heading: "Vikt",
            name: "totalWeight"
        },
        {
            get: props => {
                return CostEstimateRowsCalculator.getTotalTime(props);
            },
            heading: "Tid",
            name: "totalProductionTime"
        },
        {
            get: props => {
                return Number(
                    CostEstimateRowsCalculator.getTotalProductionCost(props)
                ).asFormattedAmount();
            },
            heading: "Overhead",
            name: "totalProductionCost"
        },
        {
            get: props => {
                return Number(
                    CostEstimateRowsCalculator.getTotalPurchasePrice(props)
                ).asFormattedAmount();
            },
            heading: "Inpris",
            name: "totalPurchasePrice"
        },
        {
            get: props => {
                return CostEstimateRowsCalculator.getTotalMargin(props) + "%";
            },
            heading: "Marginal",
            name: "undefined"
        },
        {
            get: props => {
                return Number(
                    CostEstimateRowsCalculator.getTotalUnitPrice(props)
                ).asFormattedAmount();
            },
            heading: "Pris/st",
            name: "undefined"
        },
        {
            get: props => {
                return Number(
                    CostEstimateRowsCalculator.getTotalPrice(props)
                ).asFormattedAmount();
            },
            heading: "Pris",
            name: "undefined"
        },
        {
            get: props => {
                return CostEstimateRowsCalculator.getTotalDiscount(props) + "%";
            },
            heading: "Rabatt",
            name: "undefined"
        },
        {
            get: props => {
                return Number(
                    CostEstimateRowsCalculator.getTotalUnitPriceAfterDiscount(
                        props
                    )
                ).asFormattedAmount();
            },
            heading: "Pris/st",
            name: "undefined"
        },
        {
            get: props => {
                return Number(
                    CostEstimateRowsCalculator.getTotalPriceAfterDiscount(props)
                ).asFormattedAmount();
            },
            heading: "Slutpris",
            name: "undefined"
        }
    ];

    selectedInterval = 0;

    getInterval = selectedInterval => {
        const { intervals } = this.props.globalSettings;
        const { quantity, quantities } = this.props;

        if (selectedInterval == "") {
            if (quantity != "" && quantity > 0) {
                return [...quantities];
            }
            return [];
        }

        return intervals[selectedInterval];
    };

    handleSingleRowClick = event => {
        event.preventDefault();
        const { quantity: desiredAmount } = this.props;

        this.forceUpdate(() => {
            this.props.onIntervalUpdate([desiredAmount], "");
        });
    };

    handleAutoSpreadClick = event => {
        event.preventDefault();

        const { quantity: desiredAmount, rows } = this.props;
        const rowsWithObjectsPerRow = rows.filter(row => row.objectsPerRow);

        let objectsPerRow = 1;
        if (rowsWithObjectsPerRow.length > 0) {
            objectsPerRow = rowsWithObjectsPerRow[0]["objectsPerRow"];
        }

        this.forceUpdate(() => {
            let interval = [];
            interval.push(desiredAmount);

            if (desiredAmount % objectsPerRow != 0) {
                if (objectsPerRow <= desiredAmount) {
                    let nextAmount =
                        objectsPerRow *
                        Math.ceil(desiredAmount / objectsPerRow);

                    if (nextAmount == interval[interval.length - 1]) {
                        nextAmount += objectsPerRow;
                    }
                    interval.push(nextAmount);
                } else {
                    interval.push(objectsPerRow);
                }
            }

            while (interval.length < 5) {
                interval.push(interval[interval.length - 1] * 2);
            }

            this.props.onIntervalUpdate(interval, "");
        });
    };

    handleIntervalChange = event => {
        const selectedInterval = event.target.value;

        this.forceUpdate(() => {
            this.props.onIntervalUpdate(
                this.getInterval(selectedInterval),
                selectedInterval
            );
        });

        // this.setState({ selectedInterval }, (selectedInterval) => {

        // });

        // this.forceUpdate(() => {
        //     this.props.onIntervalUpdate(this.getInterval());
        // });

        // this.forceUpdate(() => {
        //     this.props.onIntervalUpdate(this.getInterval());
        //     // this.selectedInterval = 0;
        // });
        // event.target.selectedIndex = 0;
    };

    constructor(props) {
        super(props);
    }

    renderDesiredQuantity() {
        const { isEditable, quantity } = this.props;
        const quantityIsValid = !isNaN(quantity) && parseInt(quantity) > 0;
        return (
            <Fragment>
                <div className="col-sm-3">
                    <label>Önskat antal</label>
                    {isEditable && (
                        <div className="row">
                            <div className="col-12">
                                <input
                                    className="form-control d-inline-block max100pxWide mr-2"
                                    min="1"
                                    name="quantity"
                                    onChange={event =>
                                        this.props.handleQuantityInputChange(
                                            event
                                        )
                                    }
                                    type="number"
                                    value={quantity}
                                    required
                                />
                                {isEditable && quantityIsValid && (
                                    <Fragment>
                                        <button
                                            className="btn btn-icon btn-icon--equals btn-icon--noText d-inline-block mr-2"
                                            onClick={this.handleSingleRowClick}
                                        />
                                        <button
                                            className="btn btn-icon btn-icon--auto btn-icon--noText d-inline-block"
                                            onClick={this.handleAutoSpreadClick}
                                        />
                                    </Fragment>
                                )}
                            </div>
                        </div>
                    )}
                    {!isEditable && (
                        <div className="form-control mb-2">{quantity}</div>
                    )}
                </div>
            </Fragment>
        );
    }

    render() {
        const { isEditable, rows, customer, quantity } = this.props;
        const { selectedInterval } = this.props;
        const quantityIsValid = !isNaN(quantity) && parseInt(quantity) > 0;

        const data = this.headings.reduce(
            (o, key) => ({ ...o, [key.name]: this.props[key.name] }),
            {}
        );

        const interval = this.getInterval(selectedInterval);

        return (
            <Fragment>
                <div className="row mb-2">
                    {this.renderDesiredQuantity()}
                    {isEditable && quantityIsValid && (
                        <Fragment>
                            <div className="col-sm-3 col-xl-2">
                                <label>Antalsintervall</label>
                                <div className="mb-2">
                                    <select
                                        name="selected_interval"
                                        className="form-control"
                                        onChange={event =>
                                            this.handleIntervalChange(event)
                                        }
                                        value={selectedInterval}
                                    >
                                        <option value="">
                                            Välj ett intervall
                                        </option>
                                        {this.getSpreadSelectboxLabels().map(
                                            (value, index) => {
                                                return (
                                                    <option
                                                        key={index}
                                                        value={index}
                                                    >
                                                        {value}
                                                    </option>
                                                );
                                            }
                                        )}
                                    </select>
                                </div>
                            </div>
                        </Fragment>
                    )}
                </div>
                <div className="row">
                    <div className="col pl-0">
                        {interval.length > 0 && (
                            <table className="table table-itemList table-spreadList mb-0">
                                <thead>
                                    <tr>
                                        {this.headings.map((column, index) => (
                                            <th key={index}>
                                                {column.heading}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {interval.map((multiplier, rowIndex) => {
                                        let simulatedRows = [];

                                        Object.keys(rows).map(function (
                                            key,
                                            index
                                        ) {
                                            let row = { ...rows[key] };
                                            simulatedRows.push(row);
                                        });

                                        return (
                                            <tr key={rowIndex}>
                                                {this.headings.map(
                                                    (column, columnIndex) => {
                                                        return (
                                                            <td
                                                                key={
                                                                    columnIndex
                                                                }
                                                            >
                                                                <Interval
                                                                    column={
                                                                        column
                                                                    }
                                                                    columnIndex={
                                                                        columnIndex
                                                                    }
                                                                    isEditable={
                                                                        isEditable
                                                                    }
                                                                    multiplier={
                                                                        multiplier
                                                                    }
                                                                    onQuantityChange={
                                                                        this
                                                                            .props
                                                                            .onQuantityChange
                                                                    }
                                                                    rowIndex={
                                                                        rowIndex
                                                                    }
                                                                    data={data}
                                                                    rows={
                                                                        simulatedRows
                                                                    }
                                                                    customer={
                                                                        customer
                                                                    }
                                                                />
                                                            </td>
                                                        );
                                                    }
                                                )}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default CostEstimateSpread;
